// Planes de invitaciones disponibles
export const INVITATION_PLANS = [
  {
    id: 'clasica',
    name: 'Invitación Clásica',
    price: 'ARS 25.000',
    icon: 'https://noscasamos.ar/wp-content/uploads/sites/7/2022/07/platino.svg',
    features: [
      { text: 'Portada con fotos y colores personalizados', enabled: true },
      { text: 'Agendar fecha + Cuenta regresiva', enabled: true },
      { text: 'Información, ubicación e indicaciones', enabled: true },
      { text: 'Opciones de Regalos', enabled: true },
      { text: 'Nuestra historia', enabled: false },
      { text: 'Interactivos: Spotify e Instagram', enabled: false },
      { text: 'Gestión de invitados online', enabled: false },
      { text: 'Música de fondo', enabled: false },
      { text: 'Álbum de Fotos', enabled: false },
      { text: 'Recomendaciones', enabled: false },
      { text: 'Confirmación por WhatsApp', enabled: false }
    ],
    detailsUrl: '/producto/invitacion-clasica',
    message: 'Hola! Quiero más info sobre la Invitación Clásica',
    buttonId: 'add_classic'
  },
  {
    id: 'platino',
    name: 'Invitación Platino',
    price: 'ARS 32.000',
    icon: 'https://noscasamos.ar/wp-content/uploads/sites/7/2022/07/platino.svg',
    features: [
      { text: 'Portada con fotos y colores personalizados', enabled: true },
      { text: 'Agendar fecha + Cuenta regresiva', enabled: true },
      { text: 'Información, ubicación e indicaciones', enabled: true },
      { text: 'Opciones de Regalos', enabled: true },
      { text: 'Nuestra historia', enabled: true },
      { text: 'Interactivos: Spotify e Instagram', enabled: true },
      { text: 'Confirmación por WhatsApp', enabled: true },
      { text: 'Música de fondo', enabled: true },
      { text: 'Álbum de Fotos', enabled: false },
      { text: 'Recomendaciones', enabled: false },
      { text: 'Gestión de invitados online', enabled: false }
    ],
    detailsUrl: '/producto/invitacion-platino',
    message: 'Hola! Quiero más info sobre la Invitación Platino',
    buttonId: 'add_platino',
    featured: true
  },
  {
    id: 'gold',
    name: 'Invitación Gold',
    price: 'ARS 40.000',
    icon: 'https://noscasamos.ar/wp-content/uploads/sites/7/2022/07/gold.svg',
    features: [
      { text: 'Portada con fotos y colores personalizados', enabled: true },
      { text: 'Agendar fecha + Cuenta regresiva', enabled: true },
      { text: 'Información, ubicación e indicaciones', enabled: true },
      { text: 'Opciones de Regalos', enabled: true },
      { text: 'Nuestra Historia', enabled: true },
      { text: 'Interactivos: Spotify e Instagram', enabled: true },
      { text: 'Confirmación por WhatsApp o email', enabled: true },
      { text: 'Panel de Gestion de Invitados Online', enabled: true },
      { text: 'Invitaciones individuales', enabled: true },
      { text: 'Música de fondo', enabled: true },
      { text: 'Álbum de Fotos', enabled: true },
      { text: 'Recomendaciones', enabled: true }
    ],
    detailsUrl: '/producto/invitacion-gold',
    message: 'Hola! Quiero más info sobre la Invitación Gold',
    buttonId: 'add_gold'
  }
];
